"use strict";

exports.__esModule = true;
exports.default = void 0;
const normalizePermission = permission => {
  if (typeof permission === "string") {
    return {
      name: permission,
      customerId: null
    };
  }
  // Makes sure that customerId is null if its not set
  return {
    customerId: null,
    ...permission
  };
};
var _default = exports.default = normalizePermission;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJub3JtYWxpemVQZXJtaXNzaW9uIiwicGVybWlzc2lvbiIsIm5hbWUiLCJjdXN0b21lcklkIiwiX2RlZmF1bHQiLCJleHBvcnRzIiwiZGVmYXVsdCJdLCJzb3VyY2VzIjpbIm5vcm1hbGl6ZVBlcm1pc3Npb24uanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3Qgbm9ybWFsaXplUGVybWlzc2lvbiA9IChwZXJtaXNzaW9uKSA9PiB7XG4gICAgaWYgKHR5cGVvZiBwZXJtaXNzaW9uID09PSBcInN0cmluZ1wiKSB7XG4gICAgICAgIHJldHVybiB7IG5hbWU6IHBlcm1pc3Npb24sIGN1c3RvbWVySWQ6IG51bGwgfTtcbiAgICB9XG4gICAgLy8gTWFrZXMgc3VyZSB0aGF0IGN1c3RvbWVySWQgaXMgbnVsbCBpZiBpdHMgbm90IHNldFxuICAgIHJldHVybiB7IGN1c3RvbWVySWQ6IG51bGwsIC4uLnBlcm1pc3Npb24gfTtcbn07XG5leHBvcnQgZGVmYXVsdCBub3JtYWxpemVQZXJtaXNzaW9uO1xuIl0sIm1hcHBpbmdzIjoiOzs7O0FBQUEsTUFBTUEsbUJBQW1CLEdBQUlDLFVBQVUsSUFBSztFQUN4QyxJQUFJLE9BQU9BLFVBQVUsS0FBSyxRQUFRLEVBQUU7SUFDaEMsT0FBTztNQUFFQyxJQUFJLEVBQUVELFVBQVU7TUFBRUUsVUFBVSxFQUFFO0lBQUssQ0FBQztFQUNqRDtFQUNBO0VBQ0EsT0FBTztJQUFFQSxVQUFVLEVBQUUsSUFBSTtJQUFFLEdBQUdGO0VBQVcsQ0FBQztBQUM5QyxDQUFDO0FBQUMsSUFBQUcsUUFBQSxHQUFBQyxPQUFBLENBQUFDLE9BQUEsR0FDYU4sbUJBQW1CIiwiaWdub3JlTGlzdCI6W119